export const DEFAULT_VALUES = {
  PlaceName: '',
  PlaceORI: '',
  PlaceDepartmentID: '',
  PlaceType: '',
  IsDestination: false,
  ptsAddressID: null,
  IsPrimary: false,
  ContactMethod: '',
  ContactMethodType: '',
  Info: '',
  IsDefault: true,
  Notes: '',
};
